module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-3-1e91104d1023f719a43c94f31afbc053.png";